import { PixelLoaderService } from './pixel-loader-service';
import { JwtTokenService } from './jwt-token.service';
import { fromEvent, of, zip } from 'rxjs';
import { map, mergeMap, switchMap } from 'rxjs/operators';
import { CorrelationidService } from './correlationid.service';
import { oauthLogger } from '../utils/logging.utils';
import { LoginCookieService } from './login-cookie.service';
import { Globals } from '../types/globals';
export class TokenService {
  constructor(correlationidService = new CorrelationidService(), pixelLoaderService = new PixelLoaderService(), jwtTokenService = new JwtTokenService()) {
    this.correlationidService = correlationidService;
    this.pixelLoaderService = pixelLoaderService;
    this.jwtTokenService = jwtTokenService;
    this.checkSessionExpired();
  }
  resetBy(config) {
    const resettables = [this.jwtTokenService, this.pixelLoaderService, this.correlationidService];
    resettables.forEach((resettable) => resettable.resetBy(config));
  }
  resetToken() {
    this.resetBy(this.config);
  }
  fetchOptions(options, config, expectJwt = true) {
    this.config = config;
    const optionsToFetch = this.authorize(options, config, expectJwt);
    return of(null).pipe(mergeMap(() => zip(...optionsToFetch)), switchMap(() => of(options)));
  }
  authorize(options, config, expectJwt = true) {
    // set OAG Header
    if (config && config.clientId) {
      const headers = options.headers;
      headers.set('X-API-Key', config.clientId);
      options.headers = headers;
    }
    const optionsToFetch = [];
    optionsToFetch.push(this.correlationidService.fetchOptions(options, config));
    // check ob überhaupt angemeldet => ansonsten keine Anfrage an den OAM
    if (this.checkLoggedIn(config)) {
      if (options.requestType.isJwtNecessary()) {
        optionsToFetch.push(this.pixelLoaderService.fetchOptions(options, config).pipe(mergeMap(() => {
          return this.jwtTokenService.fetchOptions(options, config, expectJwt);
        })));
      }
      else {
        oauthLogger.info('Keine Anfrage an den OAM notwendig!');
      }
    }
    else {
      oauthLogger.info('Kein Benutzer angemeldet, deshalb werden baicon und JWT nicht abgefragt!');
    }
    return optionsToFetch;
  }
  checkLoggedIn(config) {
    if (!config || !config.oamHost) {
      return false;
    }
    // in welcher Umgebung sind wir? relevant vor allem in Testumgebungen
    LoginCookieService.setUmgebungFromOamHost(config.oamHost);
    const loginstatus = LoginCookieService.getLoginStatus();
    if (loginstatus === LoginCookieService.LoginStatus.LOGGEDIN
      || loginstatus === LoginCookieService.LoginStatus.UNKNOWN) {
      return true;
    }
    return false;
  }
  checkSessionExpired() {
    fromEvent(Globals.sessionExpired, 'sessionExpired')
      .pipe(map(() => {
      oauthLogger.warn('Session ist abgelaufen! Cache wird geleert.');
      this.resetToken();
    }))
      .subscribe();
  }
}
//# sourceMappingURL=token.service.js.map
